import React, { Component } from "react";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";

import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
} from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import isEmpty from "../../../../store/validation/is-Empty";
import Switch from "react-switch";
import { HealthAndSenitationScreenOne } from "./InsideScreenHealth/HealthAndSenitationScreenOne";
import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import Media from "react-media";

export class VendorHealthAndSenitationEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editButton: false,
      actionButton: false,
      loader: false,
      hasSetMapProps: false,
      healthAndSanitizeSwitchValue: false,
      healthandsanitization_entrypoint: [],
      // DATA
      selected_health_and_sanitization_entrypoint: [],
      primary_health_and_sanitization_entrypoint: {},
      errors: [],
    };
    this.handleHealthAndSanitizeSwitchValue =
      this.handleHealthAndSanitizeSwitchValue.bind(this);
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.health_entry_point) &&
      !nextState.hasSetMapProps
    ) {
      let selected_health_and_sanitization_entrypoint =
        nextProps.onboarding.selected_health_and_sanitization_entrypoint;
      let primary_health_and_sanitization_entrypoint =
        nextProps.onboarding.primary_health_and_sanitization_entrypoint;
      if (
        !isEmpty(
          nextProps.onboarding.primary_health_and_sanitization_entrypoint
        ) &&
        !isEmpty(selected_health_and_sanitization_entrypoint[0])
      ) {
        if (
          !isEmpty(
            nextProps.onboarding.primary_health_and_sanitization_entrypoint
          ) &&
          isEmpty(selected_health_and_sanitization_entrypoint[0]._id) &&
          selected_health_and_sanitization_entrypoint.length > 0 &&
          isEmpty(primary_health_and_sanitization_entrypoint._id)
        ) {
          selected_health_and_sanitization_entrypoint =
            nextProps.health_entry_point.filter((data) =>
              selected_health_and_sanitization_entrypoint.includes(data._id)
            );
          primary_health_and_sanitization_entrypoint =
            nextProps.health_entry_point.filter(
              (data) => data._id === primary_health_and_sanitization_entrypoint
            )[0];
        }
      }
      let all_healthandsanitization_entrypoint =
        nextProps.health_entry_point.filter(
          (point) =>
            !selected_health_and_sanitization_entrypoint.some(
              (selected) => selected._id === point._id
            )
        );
      return {
        selected_health_and_sanitization_entrypoint: !isEmpty(
          selected_health_and_sanitization_entrypoint
        )
          ? selected_health_and_sanitization_entrypoint
          : [],

        primary_health_and_sanitization_entrypoint: !isEmpty(
          primary_health_and_sanitization_entrypoint
        )
          ? primary_health_and_sanitization_entrypoint
          : {},

        healthAndSanitizeSwitchValue:
          nextProps.onboarding.healthAndSanitizeSwitchValue,
        healthandsanitization_entrypoint: all_healthandsanitization_entrypoint,
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  async handleHealthAndSanitizeSwitchValue(healthAndSanitizeSwitchValue) {
    this.setState({
      healthAndSanitizeSwitchValue,
      actionButton: true,
    });
    // if (!healthAndSanitizeSwitchValue) {
    //   for (
    //     let i = 0;
    //     i < this.state.selected_health_and_sanitization_entrypoint.length;
    //     i++
    //   ) {
    //     // Reset Array of items
    //     let {
    //       healthandsanitization_entrypoint,
    //       selected_health_and_sanitization_entrypoint,
    //       primary_health_and_sanitization_entrypoint,
    //     } = this.state;
    //     let icon = this.state.selected_health_and_sanitization_entrypoint[i];
    //     let iconIndexAtAllIcons =
    //       await healthandsanitization_entrypoint.findIndex(
    //         (icons) =>
    //           this.state.selected_health_and_sanitization_entrypoint[i]._id ===
    //           icons._id
    //       );
    //     let iconIndexAtSelectedIcons =
    //       await selected_health_and_sanitization_entrypoint.findIndex(
    //         (icons) =>
    //           this.state.selected_health_and_sanitization_entrypoint[i]._id ===
    //           icons._id
    //       );
    //     let iconAtPrimaryIcon =
    //       !isEmpty(primary_health_and_sanitization_entrypoint) &&
    //       primary_health_and_sanitization_entrypoint._id === icon._id
    //         ? true
    //         : false;
    //     if (selected_health_and_sanitization_entrypoint.length === 0) {
    //       selected_health_and_sanitization_entrypoint.push(icon);
    //       await healthandsanitization_entrypoint.splice(iconIndexAtAllIcons, 1);
    //       primary_health_and_sanitization_entrypoint = icon;
    //     } else if (iconAtPrimaryIcon) {
    //       await selected_health_and_sanitization_entrypoint.splice(
    //         iconIndexAtSelectedIcons,
    //         1
    //       );
    //       await healthandsanitization_entrypoint.push(icon);
    //       if (selected_health_and_sanitization_entrypoint.length === 1) {
    //         primary_health_and_sanitization_entrypoint =
    //           selected_health_and_sanitization_entrypoint[0];
    //       } else {
    //         primary_health_and_sanitization_entrypoint = {};
    //       }
    //     } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
    //       await selected_health_and_sanitization_entrypoint.splice(
    //         iconIndexAtSelectedIcons,
    //         1
    //       );
    //       await healthandsanitization_entrypoint.push(icon);
    //       if (selected_health_and_sanitization_entrypoint.length === 1) {
    //         primary_health_and_sanitization_entrypoint =
    //           selected_health_and_sanitization_entrypoint[0];
    //       }
    //     } else {
    //       await selected_health_and_sanitization_entrypoint.push(icon);
    //       await healthandsanitization_entrypoint.splice(iconIndexAtAllIcons, 1);
    //     }

    //     await this.setState({
    //       selected_health_and_sanitization_entrypoint:
    //         selected_health_and_sanitization_entrypoint,
    //       healthandsanitization_entrypoint: healthandsanitization_entrypoint,
    //       primary_health_and_sanitization_entrypoint:
    //         primary_health_and_sanitization_entrypoint,
    //       actionButton: true,
    //     });
    //   }

    //   this.setState({
    //     selected_health_and_sanitization_entrypoint: [],
    //     primary_health_and_sanitization_entrypoint: {},
    //   });
    // }
  }

  /********************************
   * @DESC Entery Point Handler
   ********************************/
  onEnteryPointBackButton = (e) => {
    this.setState({
      healthAndSanitizeSwitchValue: false,
      actionButton: false,
      // editButton: false,
    });
    this.props.history.push("/profile");
  };

  whithOutEnteryPointNextButton = (e) => {
    this.setState({
      actionButton: false,
      // editButton: false,
    });
    this.props.history.push("/profile");
  };

  editClick = (e) => {
    this.setState({
      editButton: !this.state.editButton,
    });
  };

  onEnteryPointNextButton = (e) => {
    let formData = {
      healthAndSanitizeSwitchValue: this.state.healthAndSanitizeSwitchValue,
      selected_health_and_sanitization_entrypoint:
        this.state.selected_health_and_sanitization_entrypoint,
      primary_health_and_sanitization_entrypoint:
        this.state.primary_health_and_sanitization_entrypoint,
      id: this.props.onboarding._id,
      vendor_id: this.props.onboarding.vendor_id,
    };
    this.props.create_and_update_restaurant(formData);
    this.setState({
      actionButton: false,
      // editButton: false,
    });
  };

  /****************************************
   * @DESC - Others Health Seafty SELECTOR
   ****************************************/
  othersHealthAndSafetyHandler = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_entrypoint;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_entrypoint;
    let primaryIcon = this.state.primary_health_and_sanitization_entrypoint;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_entrypoint: Restaurant,
        primary_health_and_sanitization_entrypoint: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_entrypoint: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyPrimarySelector = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_entrypoint: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  othersHealthAndSafetyRemoveButton = (icon) => (e) => {
    let {
      healthandsanitization_entrypoint,
      selected_health_and_sanitization_entrypoint,
      primary_health_and_sanitization_entrypoint,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_entrypoint.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_entrypoint.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_entrypoint) &&
      primary_health_and_sanitization_entrypoint._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_entrypoint.length === 0) {
      selected_health_and_sanitization_entrypoint.push(icon);
      healthandsanitization_entrypoint.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_entrypoint = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_entrypoint.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_entrypoint.push(icon);
      if (selected_health_and_sanitization_entrypoint.length === 1) {
        primary_health_and_sanitization_entrypoint =
          selected_health_and_sanitization_entrypoint[0];
      } else {
        primary_health_and_sanitization_entrypoint = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_entrypoint.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_entrypoint.push(icon);
      if (selected_health_and_sanitization_entrypoint.length === 1) {
        primary_health_and_sanitization_entrypoint =
          selected_health_and_sanitization_entrypoint[0];
      }
    } else {
      selected_health_and_sanitization_entrypoint.push(icon);
      healthandsanitization_entrypoint.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_entrypoint:
        selected_health_and_sanitization_entrypoint,
      healthandsanitization_entrypoint: healthandsanitization_entrypoint,
      primary_health_and_sanitization_entrypoint:
        primary_health_and_sanitization_entrypoint,
      actionButton: true,
    });
  };
  onSuccess = () => {
    Alert.success("<h4>Updated successfully.</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      healthAndSanitizeSwitchValue: this.state.healthAndSanitizeSwitchValue,
      vendor_id: this.props.onboarding.vendor_id,
      id: this.props.onboarding._id,
    };
    this.props.create_and_update_restaurant(formData, this.onSuccess);
    this.setState({
      actionButton: false,
      // editButton: false,
    });
  };

  renderHealthsenitationFields = () => {
    const {
      healthAndSanitizeSwitchValue,
      editButton,
      // errors,
      actionButton,
    } = this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div>
            <div className="cuisine-main">
              <div className="col-12">
                <div className="row health_and_senitation_onboarding_main_div">
                  <div className="col-9 col-sm-9 col-md-8 col-lg-8 col-xl-8 pl-0 health_and_senitation_onboarding_main_divone">
                    <h5>
                      Do you have facility maintained as per Health standards
                      and COVID-19 ?
                    </h5>
                  </div>
                  <div className="col-3 col-sm-3 col-md-4 col-lg-4 col-xl-4 p-0 health_and_senitation_onboarding_main_divtwo">
                    <Switch
                      checked={this.state.healthAndSanitizeSwitchValue}
                      onChange={this.handleHealthAndSanitizeSwitchValue}
                      onColor="#59F832"
                      onHandleColor="#ffffff"
                      disabled={editButton === false ? true : false}
                      width={52}
                      height={24}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      className="react-switch"
                      id="material-switch"
                    />
                  </div>
                </div>
              </div>

              {healthAndSanitizeSwitchValue === true ? (
                <HealthAndSenitationScreenOne
                  bigText="Following are available at Entry Point"
                  smallText="Please select items from the list below"
                  primaryBigText="Out of the features selected above, which one is primary?"
                  primarySmallText="(Select one primary feature accepted at your facility)"
                  otherHealth={this.state.healthandsanitization_entrypoint}
                  selectedOtherHealth={
                    this.state.selected_health_and_sanitization_entrypoint
                  }
                  primaryOtherHealth={
                    this.state.primary_health_and_sanitization_entrypoint
                  }
                  onRestaurantSelectorArraySelector={
                    this.othersHealthAndSafetyHandler
                  }
                  onRestaurantsPrimarySelector={
                    this.othersHealthAndSafetyPrimarySelector
                  }
                  removeButton={this.othersHealthAndSafetyRemoveButton}
                  onBackButtonClick={this.onEnteryPointBackButton}
                  onNextButtonClick={
                    actionButton === false
                      ? this.whithOutEnteryPointNextButton
                      : this.onEnteryPointNextButton
                  }
                  protocolNext={editButton === true ? true : false}
                  actionButton={actionButton}
                  extraClass={"col-6"}
                />
              ) : null}
            </div>
          </div>
          {healthAndSanitizeSwitchValue === false ? (
            <div className="col-12 p-0 d-flex justify-content-between mb-4">
              <ReusableOnboardingLink
                buttonTitle="Back Button"
                buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                buttonText="Back"
                link="/profile"
              />
              {editButton === true ? (
                <ReusableOnboardingButton
                  buttonTitle="Save Button"
                  buttonClass={
                    actionButton === false
                      ? "onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      : "onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  }
                  buttonText="Save"
                  buttonType={actionButton === false ? "button" : "submit"}
                />
              ) : null}
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/profile"
                displayText="Back"
              />
              {/* <Media query="(min-width: 991px)"> */}
              <div className="col-12 col-md-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0 mobile-mt-4">
                <div className=" p-0">
                  <div>
                    <TopTextReusableComponent
                      headingText="Health and Sanitation"
                      headingParagraph="( Please enter information about the Hygiene and Sanitation efforts and protocol )"
                      displayEdit={this.state.editButton}
                      onClickEdit={this.editClick}
                    />
                  </div>
                  <Form noValidate onSubmit={this.onHandleSubmit}>
                    {this.renderHealthsenitationFields()}
                  </Form>
                </div>
              </div>
              {/* </Media> */}
              {/* <Media query="(max-width: 991px)">
                <div className="container">
                  <div className="bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                    <div className=" p-0">
                      <div>
                        <TopTextReusableComponent
                          headingText="Health and Sanitation"
                          headingParagraph="( Please enter information about the Hygiene and Sanitation efforts and protocol )"
                          displayEdit={this.state.editButton}
                          onClickEdit={this.editClick}
                        />
                      </div>
                      <Form noValidate onSubmit={this.onHandleSubmit}>
                        {this.renderHealthsenitationFields()}
                      </Form>
                    </div>
                  </div>
                  </div>
              </Media> */}
            </div>

            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorHealthAndSenitationEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  health_entry_point: state.category.health_entry_point,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(VendorHealthAndSenitationEdit));
